import langData from './lang.json';

export const translate = (key) => {
  const lang = localStorage.getItem('lang') || 'en';
  return langData[key] ? langData[key][lang] : key;
};